import { useCallback, useEffect, useState } from "react";
import { TreeSelector } from "../../../components/TreeSelector/TreeSelector";
import { API, ShareAPI } from "../../../API";

type GeoGroupFilterProps = {
  selected: string[]; // Ensure this matches the type expected by TreeSelector
  disabled?: boolean;
  onChange: (selected: string[]) => void;
  style?: React.CSSProperties;
  isShare?: boolean;
};

type GeoRegion = {
  id: string;
  name: string;
  category: {
    id: string;
    name: string;
  };
};

export const GeoGroupFilter: React.FC<GeoGroupFilterProps> = ({
  selected,
  disabled = false,
  onChange,
  style = {},
  isShare
}) => {
  const [geoRegionsData, setGeoRegionsData] = useState<GeoRegion[] | null>(null);

  let api = isShare ? ShareAPI : API;

  const getGeoRegions = useCallback(() => {
    api.fetch("GET", `/API/v2/country-groups?category_type=GEO`).then((data) => {
      setGeoRegionsData(data);
    });
  }, []);

  useEffect(getGeoRegions, [getGeoRegions]);

  const handleChange = (selected: string[]) => {
    onChange(selected);
  };

  return (
    <TreeSelector<GeoRegion>
      items={geoRegionsData}
      selectedIds={selected as (keyof GeoRegion)[]}
      onChange={handleChange}
      idKey="id"
      labelKey="name"
      multiple={true}
      disabled={disabled}
      groupBy={(item: GeoRegion) => item.category.name}
      style={style}
    />
  );
};
